 $('document').ready(function () {
      'use strict';
 	        //var d = new Date("2017-06-04 15:01:00");
	  var d = new Date();
      document.getElementById("currentdatetime").innerHTML = d;

      var dayofweekstring = 'Tuesday';
      var year = d.getFullYear();
      var month = d.getMonth();
      var day = d.getDate();
      var hour = d.getHours();

      var start = d.getTime() / 1000;
      var now = start;
      var dayofweek = d.getDay();

      var numberOfDaysToAdd = 0;

		if (dayofweek == 1) {//Monday
        numberOfDaysToAdd = 0;
        if (hour >= 15) {
          numberOfDaysToAdd++;
          dayofweekstring = 'Wednesday';
        }
      }
      else if (dayofweek == 2) {//Tuesday
        dayofweekstring = 'Wednesday';
        if (hour >= 15) {
          numberOfDaysToAdd++;
          dayofweekstring = 'Thursday';
        }
      }
      else if (dayofweek == 3) {//Wednesday
        dayofweekstring = 'Thursday';
        if (hour >= 15) {
          numberOfDaysToAdd++;
          dayofweekstring = 'Friday';
        }
      }
       else if (dayofweek == 4) {//Thursday
        dayofweekstring = 'Friday';
        if (hour >= 15) {
          numberOfDaysToAdd = 4;
          dayofweekstring = 'Tuesday';
        }
      }
      else if (dayofweek == 5) {//Friday
        numberOfDaysToAdd = 3;
      }
      else if (dayofweek == 6) {//Saturday
        numberOfDaysToAdd = 2;
      }
      else if (dayofweek == 0) {//Sunday
          numberOfDaysToAdd++;
      }
     
   
   
   
   
   	  //need to make this 15:00 UCT
      var end = new Date(year, month, day, 15);
      end.setDate(end.getDate() + numberOfDaysToAdd);
      end = end / 1000;


      $('.countdown').final_countdown({
        'start': start,
        'end': end,
        'now': now
      });
      document.getElementById("dayofweek").innerHTML = dayofweekstring;
    });
